import React from 'react'
import styled from 'styled-components'
import { Variables } from '../styles/Variables'
import media from 'css-in-js-media'

import { Field } from 'formik'

export const StyledSelect = styled(Field)`
    -webkit-appearance: none;
    border: none;
    border-bottom: 1px solid ${Variables.color.white};
    height: 50px;
    padding: 11px 10px;
    font-family: ${Variables.font.body};
    font-size: 20px;
    font-weight: 300;
    line-height: 1;
    background: none;
    color: ${Variables.color.white};
    outline: none;
    box-sizing: border-box;
    cursor: pointer;

    option {
        color: #000000;
    }

    :disabled {
        opacity: 1;
    }
    ${media('<desktop')} {
        padding: 11px 20px;
        font-weight: 300;
        font-size: 14px;
        line-height: 28px;
        letter-spacing: 0.005em;
    }
`

const Select = ({ children, ...props }) => {
    return (
        <StyledSelect
            {...props}
        >
            {children}
        </StyledSelect>
    )
}

export default Select
